export const CDN_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_508,h_320,c_fill/";

export const LOGO_URL =
  "https://www.google.com/imgres?imgurl=https%3A%2F%2Fcdn.pixabay.com%2Fphoto%2F2017%2F02%2F21%2F08%2F49%2Ffood-2085075_1280.png&tbnid=49u5PR01_u24PM&vet=12ahUKEwj5yrrK97CBAxVZTWwGHYr2Bl8QMygkegUIARDLAQ..i&imgrefurl=https%3A%2F%2Fpixabay.com%2Fvectors%2Ffood-logo-chef-2085075%2F&docid=wo-LTPZ___hBRM&w=1280&h=1188&q=food%20logo&ved=2ahUKEwj5yrrK97CBAxVZTWwGHYr2Bl8QMygkegUIARDLAQ";
